import { configureStore } from '@reduxjs/toolkit';
import { chatApi } from '@/api/chatApi';
// import chatReducer from '@/features/chat/chatSlice';
import chatReducer from '../features/chat/chatSlice';

export const store = configureStore({
  reducer: {
    [chatApi.reducerPath]: chatApi.reducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [chatApi.util.resetApiState.type],
      },
    }).concat(chatApi.middleware),
  devTools: import.meta.env.MODE !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;